// Cliente API para bares (autenticado vía PIN + token JWT).
const API_URL = process.env.REACT_APP_BACKEND_URL;
const TOKEN_KEY = "kiltro_venue_token";
const VENUE_KEY = "kiltro_venue_info";

export const venueAuth = {
  getToken: () => localStorage.getItem(TOKEN_KEY) || null,
  getVenue: () => {
    try { return JSON.parse(localStorage.getItem(VENUE_KEY)); } catch { return null; }
  },
  setSession: (token, venue) => {
    localStorage.setItem(TOKEN_KEY, token);
    localStorage.setItem(VENUE_KEY, JSON.stringify(venue));
  },
  clear: () => {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(VENUE_KEY);
  },
};

async function authFetch(path, options = {}) {
  const token = venueAuth.getToken();
  const headers = {
    "Content-Type": "application/json",
    ...(options.headers || {}),
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };
  const res = await fetch(`${API_URL}${path}`, { ...options, headers });
  if (res.status === 401) {
    venueAuth.clear();
    const err = new Error("Sesión expirada");
    err.status = 401;
    throw err;
  }
  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    const err = new Error(body.detail || "Error");
    err.status = res.status;
    err.detail = body.detail;
    throw err;
  }
  return res.json();
}

export const venueApi = {
  loginWithPin: async (pin) => {
    const res = await fetch(`${API_URL}/api/venue/pin/login`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ pin }),
    });
    if (!res.ok) {
      const body = await res.json().catch(() => ({}));
      const err = new Error(body.detail || "PIN inválido");
      err.status = res.status;
      throw err;
    }
    return res.json();
  },
  me: () => authFetch("/api/venue/me"),
  redeem: (code) => authFetch("/api/venue/pin/redeem", { method: "POST", body: JSON.stringify({ code }) }),
  stats: () => authFetch("/api/venue/pin/stats"),
  claims: (days = 30) => authFetch(`/api/venue/pin/claims?days=${days}`),
  claimsCsvUrl: () => `${API_URL}/api/venue/pin/claims.csv`,
};
